import { useCallback } from 'react';
import {
  useSearchParams as useSearchParamsBase,
  SetURLSearchParams,
} from 'react-router-dom';
import type { NavigateOptions } from 'react-router-dom';

/**
 * Wrapper around react-router-dom's useSearchParams that defaults to
 * `replace: true` instead of push. This prevents UI state changes
 * (filters, drawers, tabs, etc.) from polluting the browser history stack.
 *
 * To explicitly push to history (e.g., breadcrumb navigation), pass
 * `{ replace: false }` as the second argument to setSearchParams.
 */
const useSearchParams = (
  ...args: Parameters<typeof useSearchParamsBase>
): ReturnType<typeof useSearchParamsBase> => {
  const [searchParams, setSearchParamsBase] = useSearchParamsBase(...args);

  const setSearchParams: SetURLSearchParams = useCallback(
    (updater: any, options?: NavigateOptions) => {
      setSearchParamsBase(updater, { replace: true, ...options });
    },
    [setSearchParamsBase],
  );

  return [searchParams, setSearchParams];
};

export default useSearchParams;
